import React, { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { selectIsHeaderNavDisplayed } from 'cityads-v3/reducers/header';
import { sendEvent } from 'cityads-v3/utils/htmlUtils';

import MenuContent from './MenuContent';
import Paper from '@material-ui/core/Paper';

import classes from './Menu.scss';

export default function MenuDesktop() {
  const docked = useSelector(state => state.menu.docked);
  const isHeaderDisplayed = useSelector(state => state.header.showHeader);
  const isHeaderNavDisplayed = useSelector(selectIsHeaderNavDisplayed);

  const containerRef = useRef(null);
  const onTransitionEnd = useCallback((evt) => {
    if (evt.target === containerRef.current) {
      sendEvent(window, 'resize');
    }
  }, []);

  return (
    <Paper
      square
      className={classNames(classes.root, {
        [classes.docked]: docked,
        [classes.headerDisplayed]: isHeaderDisplayed,
        [classes.navDisplayed]: isHeaderNavDisplayed,
      })}
      ref={containerRef}
      onTransitionEnd={onTransitionEnd}
    >
      <MenuContent/>
    </Paper>
  );
}
